import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { PreloadAllModules, RouteReuseStrategy, provideRouter, withPreloading } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CORE_PROVIDERS, PAGE_PROVIDERS } from './core/providers/core.config';
import { routes } from './app.routes';

const languageStorageKey = 'near-live:lang';

function initializeTranslations(): void {
  const translate = inject(TranslateService);
  const supported = ['pt', 'en'] as const;

  translate.addLangs([...supported]);
  translate.setFallbackLang('pt');

  let selected: (typeof supported)[number] | null = null;

  try {
    const stored = localStorage.getItem(languageStorageKey);
    if (stored === 'pt' || stored === 'en') {
      selected = stored;
    }
  } catch {
    selected = null;
  }

  if (!selected) {
    const browser = (navigator.language || '').toLowerCase();
    selected = browser.startsWith('pt') ? 'pt' : 'en';
  }

  translate.use(selected);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
        },
      }),
    ),
    provideAppInitializer(initializeTranslations),
    ...CORE_PROVIDERS,...PAGE_PROVIDERS,
  ],
};
